export namespace FeatureToggleTranslations {
  export const products = {
    productsProductFeatureToggleTitle: 'productsProductFeatureToggleTitle',

    productsDisplayEmptyStockFeatureToggleTitle: 'productsDisplayEmptyStockFeatureToggleTitle',
    productsDisplayEmptyStockFeatureToggleExplanation: 'productsDisplayEmptyStockFeatureToggleExplanation',
  } as const;

  export const order = {
    ordersProcessCompletedOrdersFeatureToggleTitle: 'ordersProcessCompletedOrdersFeatureToggleTitle',
    ordersProcessCompletedOrdersFeatureToggleExplanation: 'ordersProcessCompletedOrdersFeatureToggleExplanation',

    orderEditProductsOnDisposalFeatureToggleTitle: 'orderEditProductsOnDisposalFeatureToggleTitle',
    orderEditProductsOnDisposalFeatureToggleExplanation: 'orderEditProductsOnDisposalFeatureToggleExplanation',

    orderQuickOrderFeatureToggleTitle: 'orderQuickOrderFeatureToggleTitle',
    orderQuickOrderFeatureToggleExplanation: 'orderQuickOrderFeatureToggleExplanation',
  } as const;

  export const productTransaction = {
    productTransactionMobileFeatureToggleTitle: 'productTransactionMobileFeatureToggleTitle',
    productTransactionMobileFeatureToggleExplanation: 'productTransactionMobileFeatureToggleExplanation',
    productTransactionScanRequiredWhitelistManageUsers: 'productTransactionScanRequiredWhitelistManageUsers',
    productTransactionScanRequiredWhitelistManagementTitle: 'productTransactionScanRequiredWhitelistManagementTitle',
    productTransactionScanRequiredWhitelistManagementSubtitle:
      'productTransactionScanRequiredWhitelistManagementSubtitle',
    productTransactionScanRequiredWhitelistUpdateSuccess: 'productTransactionScanRequiredWhitelistUpdateSuccess',
    productTransactionScanRequiredWhitelistAddModalTitle: 'productTransactionScanRequiredWhitelistAddModalTitle',
    productTransactionScanRequiredWhitelistAddLabel: 'productTransactionScanRequiredWhitelistAddLabel',
    productTransactionScanRequiredWhitelistAddPlaceholder: 'productTransactionScanRequiredWhitelistAddPlaceholder',
  } as const;

  export const error = {
    featureToggleTaskOrdersAndStockUpdateCannotBeEnabledAtTheSameTime:
      'featureToggleTaskOrdersAndStockUpdateCannotBeEnabledAtTheSameTime',
    featureToggleCountContainersCannotBeEnabledWithoutContainerFeatureToggle:
      'featureToggleCountContainersCannotBeEnabledWithoutContainerFeatureToggle',
    featureToggleTaskOrdersAndRefillKitsCannotBeEnabledAtTheSameTime:
      'featureToggleTaskOrdersAndRefillKitsCannotBeEnabledAtTheSameTime',
  } as const;
}
